/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What colour format is used?`)
};

const es_cp_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué formato de color se usa?`)
};

const de_cp_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welches Farbformat wird verwendet?`)
};

const nl_cp_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welk kleurformaat wordt gebruikt?`)
};

const fr_cp_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel format de couleur est utilisé ?`)
};

const it_cp_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che formato colore viene usato?`)
};

const pt_br2_cp_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual formato de cor é usado?`)
};

const pt_cp_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que formato de cor é usado?`)
};

const ja_cp_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どのカラー形式が使われていますか?`)
};

const zh_cp_faq_q3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用的是什么颜色格式？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_faq_q3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_faq_q3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_faq_q3", locale)
	if (locale === "en") return en_cp_faq_q3(inputs)
	if (locale === "es") return es_cp_faq_q3(inputs)
	if (locale === "de") return de_cp_faq_q3(inputs)
	if (locale === "nl") return nl_cp_faq_q3(inputs)
	if (locale === "fr") return fr_cp_faq_q3(inputs)
	if (locale === "it") return it_cp_faq_q3(inputs)
	if (locale === "pt-BR") return pt_br2_cp_faq_q3(inputs)
	if (locale === "pt") return pt_cp_faq_q3(inputs)
	if (locale === "ja") return ja_cp_faq_q3(inputs)
	return zh_cp_faq_q3(inputs)
};